import Vue from 'vue'
import VueRouter from 'vue-router'
import AddCode from '../views/AddEditCode';
import Codes from '../views/Codes';
import CodeDetails from '../views/CodeDetails';
import Layout from '../views/Layout';
import Login from '../views/Login';
import SaleOffers from '../views/SaleOffers';
import ServiceOrders from '../views/ServiceOrders';
import RecordContacts from '../views/RecordContacts';
import Companies from '../views/Companies';
import PriceListCompanies from '../views/price-list/Companies';
import PriceListCompanyAdd from '../views/price-list/CompanyAdd';
import PriceListCompanyDetails from '../views/price-list/CompanyDetails';
import PriceListCompanyBranchAdd from '../views/price-list/CompanyBranchAdd';
import PriceListCompanyBranchDetails from '../views/price-list/CompanyBranchDetails';
import SaleOfferDetails from '../views/SaleOfferDetails';
import OrderDetails from '../views/OrderDetails';
import CompanyDetails from '../views/CompanyDetails';
import UserAccount from '../views/UserAccount';
import Users from '@/views/Users';
import UserDetails from '@/views/UserDetails';
import BuyOfferDetails from '@/views/BuyOfferDetails';
import Notifications from "@/views/Notifications";
import AddNotification from '../views/AddNotification';
import NotificationDetails from "@/views/NotificationDetails";
import Plans from "@/views/subscription/Plans";
import Subscriptions from "@/views/subscription/Subscriptions";
import PlanDetails from "@/views/subscription/PlanDetails";
import Orders from "@/views/transaction/Transactions";
import TransactionDetails from "@/views/transaction/TransactionDetails";
import SubscriptionDetails from "@/views/subscription/SubscriptionDetails";
import Periods from "@/views/subscription-period/Periods";
import AddOffer from "@/views/AddOffer";
import PhoneViews from "../views/PhoneViews";
import Categories from "../views/Categories";
import CategoryDetails from "../views/CategoryDetails";
import PageContents from "../views/PageContents";
import PageContentDetails from "../views/PageContentDetails";
import Redirects from "../views/Redirects";
import ServiceTypeDetails from "../views/ServiceTypeDetails";
import PriceListContents from "../views/PriceListContents";
import PriceListContentsDetails from "../views/PriceListContentsDetails";
import Services from "@/views/Services";
import OfferContents from "@/views/OfferContents";
import OfferContentDetails from "@/views/OfferContentDetails";
import OfferWantBuys from "@/views/OfferWantBuys";
import OfferJoins from "@/views/OfferJoins";
import OfferWantBuysDetails from "@/views/OfferWantBuysDetails";
import MyCompanies from "@/views/MyCompanies.vue";
import GoogleIndexing from "../views/GoogleIndexing.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '/buy-offers/:id',
                name: 'buy-offer-details',
                component: BuyOfferDetails,
                props: true,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'sale-offers',
                name: 'sale-offers',
                component: SaleOffers,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'orders',
                name: 'orders',
                component: ServiceOrders,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'records',
                name: 'records',
                component: RecordContacts,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'google-indexing',
                name: 'google-indexing',
                component: GoogleIndexing,
                meta: {
                    roles: ['ROLE_ADMIN']
                }
            },
            {
                path: 'offer-want-buys',
                name: 'offer-want-buys',
                component: OfferWantBuys,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'offer-want-buys-details/:id',
                name: 'offer-want-buys-details',
                component: OfferWantBuysDetails,
                props: true,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'offer-joins',
                name: 'offer-joins',
                component: OfferJoins,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'sale-offers/add',
                name: 'sale-offer-add',
                component: AddOffer,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: '/sale-offers/:id',
                name: 'sale-offer-details',
                component: SaleOfferDetails,
                props: true,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: '/orders/:id',
                name: 'order-details',
                component: OrderDetails,
                props: true,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'companies',
                name: 'companies',
                component: Companies,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'my-companies',
                name: 'my-companies',
                component: MyCompanies,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: '/companies/:id',
                name: 'company-details',
                component: CompanyDetails,
                props: true,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'users',
                name: 'users',
                component: Users,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: 'services',
                name: 'services',
                component: Services,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                }
            },
            {
                path: '/users/:id',
                name: 'user-details',
                component: UserDetails,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_TRADER']
                },
                props: true,
            },
            {
                path: 'codes',
                name: 'codes',
                component: Codes,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'codes/add',
                name: 'codes-add',
                component: AddCode,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'codes/:code',
                name: 'codes-details',
                component: CodeDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'notifications',
                name: 'notifications',
                component: Notifications,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'notifications/add',
                name: 'notifications-add',
                component: AddNotification,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'notifications/:id',
                name: 'notifications-details',
                component: NotificationDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'price-list-company',
                name: 'price-list-companies',
                component: PriceListCompanies,
                meta: {
                    roles: ['ROLE_ADMIN']
                }
            },
            {
                path: 'price-list-company/add',
                name: 'price-list-company-add',
                component: PriceListCompanyAdd,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'price-list-company/:id',
                name: 'price-list-company-details',
                component: PriceListCompanyDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'price-list-company/:companyId/branch/add',
                name: 'price-list-company-branch-add',
                component: PriceListCompanyBranchAdd,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'price-list-company/:companyId/branch/:id',
                name: 'price-list-company-branch-details',
                component: PriceListCompanyBranchDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'user/account',
                name: 'user-account',
                component: UserAccount,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                        'ROLE_CALL_CENTER',
                        'ROLE_TRADER',
                    ]
                }
            },
            {
                path: 'subscription-plan',
                name: 'subscription-plans',
                component: Plans,
                meta: {
                    roles: ['ROLE_ADMIN']
                }
            },
            {
                path: 'subscription-plan/:id',
                name: 'subscription-plan-details',
                component: PlanDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'subscription',
                name: 'subscriptions',
                component: Subscriptions,
                meta: {
                    roles: ['ROLE_ADMIN']
                }
            },
            {
                path: 'subscription/:id',
                name: 'subscription-details',
                component: SubscriptionDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'subscription-period/:subscriptionId?',
                name: 'subscription-periods',
                component: Periods,
                meta: {
                    roles: ['ROLE_ADMIN']
                },
                props: true,
            },
            {
                path: 'transaction',
                name: 'transactions',
                component: Orders,
                meta: {
                    roles: ['ROLE_ADMIN']
                }
            },
            {
                path: 'transaction/:id',
                name: 'transaction-details',
                component: TransactionDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'phone-views',
                name: 'phone-views',
                component: PhoneViews,
                meta: {
                    roles: ['ROLE_ADMIN']
                }
            },
            {
                path: 'categories',
                name: 'categories',
                component: Categories,
                meta: {
                    roles: ['ROLE_ADMIN']
                }
            },
            {
                path: 'category/:id',
                name: 'category-details',
                component: CategoryDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN',
                    ]
                }
            },
            {
                path: 'page-contents',
                name: 'page-contents',
                component: PageContents,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_EDITOR']
                }
            },
            {
                path: 'page-content/:id',
                name: 'page-content-details',
                component: PageContentDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN', 'ROLE_EDITOR'
                    ]
                }
            },
            {
                path: 'offer-contents',
                name: 'offer-contents',
                component: OfferContents,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_EDITOR']
                }
            },
            {
                path: 'offer-content/:id',
                name: 'offer-content-details',
                component: OfferContentDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN', 'ROLE_EDITOR'
                    ]
                }
            },
            {
                path: 'redirects',
                name: 'redirects',
                component: Redirects,
                meta: {
                    roles: ['ROLE_ADMIN']
                }
            },
            {
                path: '/service-types/:id',
                name: 'service-type-details',
                component: ServiceTypeDetails,
                meta: {
                    roles: ['ROLE_ADMIN']
                },
                props: true,
            },
            {
                path: 'price-list-contents',
                name: 'price-list-contents',
                component: PriceListContents,
                meta: {
                    roles: ['ROLE_ADMIN', 'ROLE_EDITOR']
                }
            },
            {
                path: 'price-list-contents/:id',
                name: 'price-list-contents-details',
                component: PriceListContentsDetails,
                props: true,
                meta: {
                    roles: [
                        'ROLE_ADMIN', 'ROLE_EDITOR'
                    ]
                }
            },
        ]
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
